"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogService = void 0;
const enums_1 = require("../enums");
const commweb_service_1 = require("../services/commweb-service");
const logger = __importStar(require("../logging/logger"));
const app_constants_1 = require("../app-constants");
/**
 * Event log service used by consumers wanting to log event payloads to a back end vendor log aggregator (Splunk).
 *
 * @description: Consumer event log utility
 */
class EventLogService {
    /**
     * Constructor
     * Configure and setup the Event log service
     *
     * @param apiConfig
     * @param commServicesAuthConfig
     */
    constructor(apiConfig, commServicesAuthConfig) {
        this.commWebService = new commweb_service_1.CommWebService(apiConfig);
        this.apiConfig = apiConfig;
        this.commServicesAuthConfig = commServicesAuthConfig;
    }
    /**
     * Log an <code>Event</code> to server side logging aggregator (Splunk).
     * Note first check to make sure that logging is enabled, this configuration is set server side.
     *
     * The constituent will come from the ApiConfig
     *
     * @param event {CommWebEvent} event data to log
     *
     * @return a resolved or rejected <code>Promise</code>
     */
    logMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.apiConfig.eventLogEnabled) {
                const apiRequest = {
                    method: enums_1.HttpMethod.POST,
                    url: this.apiConfig.commServicesUrls.eventLogUrl + this.apiConfig.constituent,
                    customHeaders: { Authorization: 'Bearer ' + this.commServicesAuthConfig.authToken },
                    data: event
                };
                return new Promise((resolve, reject) => {
                    this.commWebService.sendRequest(apiRequest).then((response) => {
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.code === 0) {
                            resolve(response.data);
                        }
                        else {
                            reject('[monitoring-splunk] Error: response is not valid.');
                        }
                    }).catch((error) => {
                        const errMsg = '[monitoring-splunk] Error: calling logMessage() ';
                        logger.error(errMsg, error);
                        reject(errMsg + error);
                    });
                });
            }
            else {
                return Promise.resolve({ code: 0, text: app_constants_1.LOGGING_IS_DISABLED_MESSAGE });
            }
        });
    }
}
exports.EventLogService = EventLogService;
//# sourceMappingURL=event-log-service.js.map